/* globals Blob */
'use strict';
var toString = Object.prototype.toString;

module.exports = function (x) {
	return x instanceof Blob || toString.call(x) === '[object Blob]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-blob/index.js
// module id = 861
// module chunks = 0